var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9607 4.27036C13.3212 4.63085 13.3212 5.21531 12.9607 5.57579L6.80686 11.7296C6.44638 12.0901 5.86192 12.0901 5.50143 11.7296L3.03989 9.2681C2.67941 8.90761 2.67941 8.32315 3.03989 7.96267C3.40038 7.60219 3.98484 7.60219 4.34532 7.96267L6.15415 9.77149L8.90471 7.02093L11.6553 4.27036C12.0158 3.90988 12.6002 3.90988 12.9607 4.27036Z",
    fill: "#00BA4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9607 5.57579C13.3212 5.21531 13.3212 4.63085 12.9607 4.27036C12.6002 3.90988 12.0158 3.90988 11.6553 4.27036L8.90471 7.02093L6.15415 9.77149L4.34532 7.96267C3.98484 7.60219 3.40038 7.60219 3.03989 7.96267C2.67941 8.32315 2.67941 8.90761 3.03989 9.2681L5.50143 11.7296C5.86192 12.0901 6.44638 12.0901 6.80686 11.7296L12.9607 5.57579Z",
    fill: "#00BA4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.31945a66c694ee7e270599143429e62d.svg";
export { ForwardRef as ReactComponent };